import { render, staticRenderFns } from "./SupplierOrders.vue?vue&type=template&id=a50ba32a&scoped=true"
import script from "./SupplierOrders.vue?vue&type=script&lang=js"
export * from "./SupplierOrders.vue?vue&type=script&lang=js"
import style0 from "./SupplierOrders.vue?vue&type=style&index=0&id=a50ba32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ba32a",
  null
  
)

export default component.exports